/* eslint-disable*/

import { createSlice } from '@reduxjs/toolkit';

type CountValue = {
  value: number;
};
const initialState: CountValue = {
  value: 22,
};
const counterSlice = createSlice({
  name: 'COUNTER',
  initialState,
  reducers: {
    increment(state) {
      state.value++;
    },
    decrement(state) {
      state.value--;
    },
  },
});

export const { increment, decrement } = counterSlice.actions;
export default counterSlice.reducer;
